import type {TimelineStageStatus} from '../BuildLog.types'

export const getLastKnownStatus = (
  statuses: ReadonlyArray<TimelineStageStatus> | null | undefined,
): TimelineStageStatus | null | undefined => {
  if (statuses == null || statuses.length === 0) {
    return null
  }

  let status: TimelineStageStatus = statuses[statuses.length - 1]

  if (statuses.length > 1 && status === 'UNKNOWN') {
    status = statuses[statuses.length - 2]
  }

  return status
}
